import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Table from "../../../Common/Box/Table";
import {
  capitalizePhrase,
  formatNumber,
  formatPercentage,
} from "../../../../utilities";

const number = 1;

const format = (n) =>
  n !== 0
    ? formatNumber(n, {
        significantDigits: 3,
      })
    : "";

const useStyles = makeStyles((theme) => ({
  changeGroupBoundary: {
    borderLeft: `1px solid ${theme.table.border.primary}`,
  },
  nameGroupBoundary: {
    borderRight: `1px solid ${theme.table.border.primary}`,
  },
  table: {
    borderCollapse: "collapse",
    fontSize: theme.table.fontSize,
    "& tbody tr": {
      borderTop: `1px solid ${theme.table.border.primary}`,
    },
    "& tbody tr:first-child": {
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& tbody tr:last-child": {
      fontWeight: "bold",
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& td": {
      padding: theme.table.cellPadding,
      textAlign: "right",
      whiteSpace: "nowrap",
    },
    "& td:first-child": {
      textAlign: "left",
    },
    "& th": {
      padding: theme.table.cellPadding,
      whiteSpace: "nowrap",
    },
    "& tr:last-child td:not(:first-child)": {
      minWidth: "6rem",
    },
  },
  total: {
    backgroundColor: theme.palette.area.background,
  },
}));

const ApacCsT1 = (props) => {
  const classes = useStyles();

  return (
    <Table
      key="APAC_CS_t1"
      number={number.toString()}
      title="Abortion and PAC Services by Type"
      subtitle={`${capitalizePhrase(
        props.regionName
      )} and all Low- and Middle-Income Countries, 2019`}
    >
      {props.data && (
        <table className={classes.table}>
          <thead>
            <tr>
              <th />
              <th className={classes.total}>Total</th>
              <th>Abortion</th>
              <th>PAC</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map((countryGroup) => (
              <tr key={countryGroup.name}>
                <td>{countryGroup.name}</td>

                {countryGroup.contraceptionTypes.map((contraceptionType) => (
                  <td
                    key={contraceptionType.name}
                    className={
                      contraceptionType.name === "Total"
                        ? classes.total
                        : undefined
                    }
                  >
                    {format(contraceptionType.services)}
                  </td>
                ))}
              </tr>
            ))}

            <tr>
              <td>Share in region</td>

              {[0, 1, 2].map((contraceptionTypeIndex) => (
                <td
                  key={contraceptionTypeIndex}
                  className={
                    contraceptionTypeIndex === 0 ? classes.total : undefined
                  }
                >
                  {formatPercentage(
                    (props.data[0].contraceptionTypes[contraceptionTypeIndex]
                      .services /
                      props.data.slice(-1)[0].contraceptionTypes[
                        contraceptionTypeIndex
                      ].services) *
                      100
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      )}
    </Table>
  );
};

ApacCsT1.propTypes = {
  regionName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      contraceptionTypes: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          services: PropTypes.number.isRequired,
        })
      ).isRequired,
    })
  ),
};

export default ApacCsT1;
